import React from "react";
import LoadingOverlay from "react-loading-overlay";
import { AgGridReact } from "ag-grid-react";

import ApproveDenyRenderer from "../Renderers/ApproveDenyRenderer";
import "./AccessRequests.css";

const AccessRequests = ({
  accessRequests,
  isAccessRequests,
  getAccessRequestDetail
}) => {
  const columnDefs = [
    {
      headerName: "Request Type",
      field: "requestType",
      width: 130,
      comparator: stringDataComparator
    },
    {
      headerName: "Request Date",
      field: "createdDateView",
      width: 110,
      comparator: dateComparator,
    },
    {
      headerName: "Company Name",
      colId: "vendorCorpName",
      field: "vendorCorpName",
      width: 110,
      comparator: stringDataComparator
    },
    {
      headerName: "Duns",
      field: "duns",
      width: 80,
      comparator: numericDataComparator
    },
    {
      headerName: "Vendor Name",
      field: "vendorName",
      width: 150,
      comparator: stringDataComparator
    },
    {
      headerName: "Vendor Email",
      field: "userEmail",
      width: 200,
      comparator: stringDataComparator
    },
    {
      headerName: "Merchant Email",
      field: "merchantEmail",
      width: 200,
      comparator: stringDataComparator
    },
    {
      headerName: "Vendor Fulfillment Type",
      field: "merchandiseType",
      width: 160,
      comparator: stringDataComparator
    },
    {
      headerName: "Approve / Deny",
      field: "approveDeny",
      width: 160,
      sortable: false,
      filter: false,
      cellRendererFramework: ApproveDenyRenderer,
      cellRendererParams: {
        getAccessRequestDetail: getAccessRequestDetail,
      },
    },
  ];
  const defaultColDef = {
    lockVisible: true,
    suppressMovable: true,
    filter: true,
    sortable: true,
    resizable: true,
  };
  let gridApi = null;

  function stringDataComparator(valueA, valueB) {
    const valueALower = (valueA && valueA !== "") ? valueA.toLowerCase().trim() : valueA;
    const valueBLower = (valueB && valueB !== "") ? valueB.toLowerCase().trim() : valueB;
    if (valueALower && valueBLower) {
      return (valueALower === valueBLower) ? 0 : valueALower.localeCompare(valueBLower, 'en', { numeric: true });
    } else if (valueALower && (valueBLower === null || valueBLower === "")) {
      return -1;
    } else if ((valueALower === null || valueALower === "") && valueBLower) {
      return 1;
    } else {
      return -1;
    }
  }

  function numericDataComparator(valueA, valueB) {
    const valueA0 = (valueA && valueA.indexOf('-') > -1) ? valueA.split('-')[0] : ((valueA && valueA.indexOf(',') > -1) ? valueA.split(',')[0] : valueA);
    const valueB0 = (valueB && valueB.indexOf('-') > -1) ? valueB.split('-')[0] : ((valueB && valueB.indexOf(',') > -1) ? valueB.split(',')[0] : valueB);
    const valueA1 = (valueA && valueA.indexOf('-') > -1) ? valueA.split('-')[1] : ((valueA && valueA.indexOf(',') > -1) ? valueA.split(',')[1] : null);
    const valueB1 = (valueB && valueB.indexOf('-') > -1) ? valueB.split('-')[1] : ((valueB && valueB.indexOf(',') > -1) ? valueB.split(',')[1] : null);
    if (valueA0 && valueB0) {
      if (parseInt(valueA0.trim(), 10) === parseInt(valueB0.trim(), 10)) {
        if (valueA1 && valueB1 && !isNaN(valueA1) && !isNaN(valueB1)) {
          return (parseInt(valueA1.trim(), 10) === parseInt(valueB1.trim(), 10)) ? 0 : (parseInt(valueA1.trim(), 10) > parseInt(valueB1.trim(), 10)) ? 1 : -1;
        } else if (valueA1 && valueB1 && isNaN(valueA1) && isNaN(valueB1)) {
          return (valueA1.trim().toLowerCase() === valueB1.trim().toLowerCase()) ? 0 : (valueA1.trim().toLowerCase() > valueB1.trim().toLowerCase()) ? 1 : -1;
        } else {
          return 0;
        }
      } else {
        return (parseInt(valueA0.trim(), 10) > parseInt(valueB0.trim(), 10)) ? 1 : -1;
      }
    } else if (valueA0 && valueB0 === null) {
      return -1;
    } else if (valueA0 === null && valueB0) {
      return 1;
    } else {
      return -1;
    }
  }

  function dateComparator(date1, date2) {
    let date1Number = Date.parse(date1);
    let date2Number = Date.parse(date2);
    if (
      (isNaN(date1Number) || date1Number === null) &&
      (isNaN(date2Number) || date2Number === null)
    ) {
      return 0;
    }
    if (isNaN(date1Number) || date1Number === null) {
      return -1;
    }
    if (isNaN(date2Number) || date2Number === null) {
      return 1;
    }
    return date1Number - date2Number;
  };


  const onGridReady = (params) => {
    gridApi = params.api;
    if (gridApi) {
      // Set default sort order
      const sort = [
        {
          colId: "vendorCorpName",
          sort: "asc"
        }
      ];
      gridApi.sizeColumnsToFit();
      gridApi.setSortModel(sort);
    }
  };

  return (
    <div className="accessRequests">
      <LoadingOverlay active={isAccessRequests} spinner>
        <div className="ag-theme-balham accessRequestsTable">
          <AgGridReact
            columnDefs={columnDefs}
            rowData={accessRequests}
            defaultColDef={defaultColDef}
            rowSelection="multiple"
            paginationPageSize="20"
            pagination={true}
            overlayNoRowsTemplate={
              accessRequests.length > 0
                ? ""
                : "No Access Requests detail available."
            }
            onGridReady={onGridReady}
          />
        </div>
      </LoadingOverlay>
    </div>
  );
};

export default AccessRequests;
